<!-- src/layouts/Sidebar.vue -->
<template>
  <div class="sidebar" :class="{ active }">
    <div class="menu">
      <div
        :class="['menu-item', { active: isActive(item) }]"
        v-for="item in menuItems"
        :key="item.name"
        @click="navigateTo(item)"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sidebar",
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menuItems: [
        { name: "home", label: "首页", path: "/" },
        { name: "game", label: "游戏产品", path: "/game" },
        { name: "about", label: "关于飓风", path: "/about" },
        { name: "Creative", label: "合作共创", path: "/Creative" },
        { name: "new", label: "新闻公告", path: "/new" },
        { name: "join", label: "加入我们", path: "/join" },
        { name: "gameplay", label: "玩家服务", path: "/gameplay" },
      ],
    };
  },
  methods: {
    isActive(item) {
      return this.$route.path === item.path;
    },
    navigateTo(item) {
      if (this.$route.path !== item.path) {
        this.$emit("close");
        this.$router.push(item.path);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  position: fixed;
  left: -252px;
  top: 48px;
  bottom: 0;
  width: 252px;
  background-color: #141414;
  color: white;
  z-index: 9999;
  transition: left 0.3s ease;
  overflow: auto;
  &.active {
    left: 0;
  }
  .menu {
    padding: 0 22px 0 18px;
    box-sizing: border-box;
    .menu-item {
      height: 54px;
      line-height: 54px;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      border-bottom: 1px solid rgba($color: #fff, $alpha: 0.15);
      cursor: pointer;
      &.active {
        color: #dc2323;
      }
    }
  }
}
</style>
